import React from 'react'
import { connect } from 'react-redux'
import {fetchMasterPlayList, recordHeartbeat, recordUserAttendance} from '../networking/Api'
import { getEntitlementName, getPlaybackUrl, saveEntitlementName, savePlaybackUrl } from '../utils/Prefs'
import CircularProgress from '@mui/material/CircularProgress'
import VideoPlayer from '../components/VideoPlayer'
import Paper from '@mui/material/Paper'
import { generateEventId } from '../utils/Utils'
import { ReactComponent as InActiveLogo } from '../cloud_off-black-48dp.svg'
import { useLocation, useNavigate } from 'react-router-dom';

function PlaybackPageWrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    return <PlaybackPage {...props} location={location} navigate={navigate} />;
}

class PlaybackPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            streamActive: false,
            width: 0,
            height: 0
        }
        this.heartbeatCall = this.heartbeatCall.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
        this.metadataCallback = this.metadataCallback.bind(this)
    }

    componentDidMount() {
        const { playbackUrl } = this.props
        this.setState(prevState => ({
            ...prevState,
            isLoading: true
        }))
        if (playbackUrl != null) {
            fetchMasterPlayList(playbackUrl).then(resp => {
                this.setState(prevState => ({
                    ...prevState,
                    isLoading: false,
                    streamActive: resp
                }))
            }).catch(err => {
            })
        }
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
        if(this.intervalId) {
            clearInterval(this.intervalId)
        }
    }

    updateWindowDimensions() {
        //this.setState({ width: window.innerWidth, height: window.innerHeight })
    }

    render() {
        const { location, navigate } = this.props;
        const playbackUrl = location?.state?.playbackUrl;
        const poster = location?.state?.poster;
        // Optionally, get entitlementName if needed
        // const entitlementName = location?.state?.entitlementName;
        const { isLoading, streamActive } = this.state;
        if (!playbackUrl) {
            // If playbackUrl is missing, redirect or show an error
            return (
                <div style={{ padding: 40, textAlign: 'center' }}>
                    <h2>Invalid access to playback page.</h2>
                    <button onClick={() => navigate('/')}>Go Home</button>
                </div>
            );
        }
        return (
            <div  >
                <div>
                    <header >
                        <h1 className="display-4 "><u>Ra</u> <u>Dha</u> <u>Sva</u> <u>Aa</u> <u>Mi</u></h1>
                        <p className="lead">Welcome to eSatsang Service.
                        <span className="text-primary"> </span>
                        </p>
                    </header>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                    {isLoading === true ?
                        <CircularProgress /> : (
                            streamActive === true ? <VideoPlayer {...{
                                metadataCallback: this.metadataCallback,
                                autoPlay: true,
                                controls: true,
                                poster,
                                playbackUrl
                            }} /> : <InactiveStream />
                        )
                    }
                </div>
            </div>
        )
    }

    metadataCallback() {
        recordUserAttendance(generateEventId(), this.props.entitlementName, this.props.dispatch).catch(err => { })
        this.heartbeatCall()
    }

    heartbeatCall() {
        recordHeartbeat(generateEventId(), this.props.entitlementName, this.props.dispatch)
            .then(data => {
                return data.code !== 1000;
            })
            .then(status => {
                if(status === false) {
                    window.location.href = '/'
                }
            })
            .catch(err => {
            })
        this.intervalId = setInterval(() => {
            recordHeartbeat(generateEventId(), this.props.entitlementName, this.props.dispatch)
                .then(data => data.code !== 1000)
                .then(status => {
                    if (status === false) {
                        window.location.href = '/';
                    }
                })
                .catch(err => { });
        }, 300000);
    }
}


class InactiveStream extends React.Component {
    render() {
        return (<div>
            <Paper style={{ height: 160, width: 300, paddingTop: 32, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
                <InActiveLogo />
                <div>Stream is not live right now</div>
            </Paper>
        </div>)
    }
}

const mapStateToProps = (store, ownProps) => {
    const { entitlements } = store
    let playbackUrl = null;
    let entitlementName = null;
    // Defensive: ensure entitlements and entitlement exist
    if (entitlements && entitlements.entitlement) {
        playbackUrl = entitlements.entitlement.playbackUrl;
        entitlementName = entitlements.entitlement.entitlementName;
        if (playbackUrl != null) {
            savePlaybackUrl(playbackUrl)
        }
        if (entitlementName != null) {
            saveEntitlementName(entitlementName)
        }
    }
    // Defensive: check ownProps.location and ownProps.location.state
    if (playbackUrl == null && ownProps.location && ownProps.location.state) {
        playbackUrl = ownProps.location.state.playbackUrl;
        if (playbackUrl != null) {
            savePlaybackUrl(playbackUrl)
        }
    }
    if (entitlementName == null && ownProps.location && ownProps.location.state) {
        entitlementName = ownProps.location.state.entitlementName;
        if (entitlementName != null) {
            saveEntitlementName(entitlementName)
        }
    }
    // Fallback to Prefs utils
    if (playbackUrl == null) {
        playbackUrl = getPlaybackUrl();
        if (playbackUrl != null) {
            savePlaybackUrl(playbackUrl)
        }
    }
    if (entitlementName == null) {
        entitlementName = getEntitlementName();
        if (entitlementName != null) {
            saveEntitlementName(entitlementName)
        }
    }
    return {
        ...ownProps,
        playbackUrl,
        entitlementName
    }
}

export default connect(mapStateToProps)(PlaybackPageWrapper)
